<template>

  <div>
    <Navbar/>
    <router-view />
    <Footer/>
</div>

</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/Footer.vue'


export default {

  name: 'App',
  components: {
    Navbar,
    Footer
  },
  methods:{
    scrollToTop() {
      window.scrollTo(0,0);
    }
  },
  metaInfo() {
        return { 
            title: "Agrivitech - Solutions digitales pour les coopératives et négoces agricoles.",
            meta: [
                { name: 'robots', content: 'index,follow'},
                { name: 'title', content: "Agrivitech - Solutions digitales pour les coopératives agricoles."},
                { name: 'description', content: 'Agrivitech - Solutions digitales pour les coopératives agricoles.'},
                { property: 'og:title', content: "Agrivitech - Solutions digitales pour les coopératives et négoces agricoles."},
                { property: 'og:description', content: "De l'appro / collecte à l'optimisation des livraisons, AgriVitech propose une solution digitale web et mobile complète pour les coopératives et les négoces agricoles de toutes tailles."},
                { property: 'og:site_name', content: 'AgriVitech'},
                { property: 'og:type', content: 'website'},    
                { property: 'og:url', content: 'https://www.agrivitech.com.com'},
                { property: 'og:image', content: 'https://www.agrivitech.com/seo-agrivitech.png' },
                { property:"twitter:card", content:"summary_large_image"},
                { property:"twitter:url" , content: 'https://www.agrivitech.com.com'},
                { property:"twitter:title" , content:"Agrivitech - Solutions digitales pour les coopératives et négoces agricoles." },
                { property:"twitter:description" , content:"De l'appro / collecte à l'optimisation des livraisons, AgriVitech propose une solution digitale web et mobile complète pour les coopératives et les négoces agricoles de toutes tailles." },
                { property:"twitter:image" , content:'https://www.agrivitech.com/seo-agrivitech.png' }
            ]
        }
    }
   
}






</script>


<style lang="scss">

@font-face {
  font-family: "Modelica";
  font-weight: 100 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Hairline.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 200 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Thin.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 300 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Light.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 400 ;
  src: local("Modelica"),
  url(./assets/font/Modelica/BwModelicaSS01-Regular.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 500 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Medium.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 600 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Bold.woff) format("woff");
}

@font-face {
  font-family: "Modelica";
  font-weight: 700 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-ExtraBold.woff) format("woff"),
}

@font-face {
  font-family: "Modelica";
  font-weight: 800 ;
  src: local("Modelica"),
   url(./assets/font/Modelica/BwModelicaSS01-Black.woff) format("woff"),
}

:root {
    // --mainGreen: #04F176 ;
    --mainGreen:#22e39e ;
    --mainBlue: #132251;
    --mainFleet: #089992;
    --mainFont: "Modelica", Avenir, Helvetica, Arial, sans-serif;
    --amplify-primary-color: var(--mainBlue);
    --amplify-primary-tint: var(--mainGreen);
    --amplify-primary-shade: var(--mainBlue);
    --amplify-font-family: var(--mainFont);
  }

#app {

  font-family: "Modelica", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: 14px;

  color: var(--mainBlue);

  overflow-x: hidden; //horizontal

  .green {
    color: var(--mainGreen);
  }

  .title{
    text-align: center;
    font-weight: 700;
    font-size: 40px;
    color: var(--mainBlue);
    padding: 50px 0px;
  }

  .subTitle{
    font-weight: 500;
    font-size: 35px;
    color: var(--mainBlue);
    padding-bottom: 50px;
  }


  .highlighted{
    font-weight: 600;
    font-size: 25px;
    color: var(--mainGreen);
    padding: 30px 0px;
  }

  .btn {
    border-radius: 25px;
    -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
  }

  .btn-more{
    font-size: 13px;
    color: var(--mainGreen);
    font-weight: 600;
    text-decoration: underline;
  }

  .btn-light{
    &:hover{
      color: var(--mainGreen);
    }
  }

  .btn-light-dark{
    background-color: transparent;
    border: none;
    color: var(--mainBlue);
    &:hover{
      color: var(--mainGreen);
    }
  }

  .btn-primary{
    background-color: var(--mainBlue);
    color: white;
    border: var(--mainBlue) 2px solid;
    border-radius: 5px;
    &:hover{
      color: var(--mainGreen);
    }
  }

  .btn-secondary{
    background-color: var(--mainGreen);
    color: white;
    border: var(--mainGreen) 2px solid;
    border-radius: 5px;
    &:hover{
      color: var(--mainBlue);
    }
  }

  .btn-secondary-outline {
    background-color: white;
    color: var(--mainBlue);
    border: var(--mainGreen) 2px solid;
    border-radius: 5px;
    &:hover{
      color: var(--mainGreen);
    }
  }

  .btn-back{
    font-weight: 500;
    font-size: 14px;
    color: var(--mainGreen);
  }

  .embed-responsive {
    border-radius: 20px;
  }

  .shadowed {
    -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
  }

  .clients-logo{
    .logoContainer{
      background-color: #f9f9f9;
      padding: 5px;
      border-radius: 25px;
      border: white 10px solid;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        margin-top: 15px;
        margin-bottom: 5px;
        filter: grayscale(100%);
      }
      &:hover {
        img{
          filter: none;
        }
      }
    }
  }

  .router-link-active {
    border-bottom: white 2px solid;
  }

}
</style>
